// extracted by mini-css-extract-plugin
export default {"modal":"ModalLogout_modal__7JU27","overlay":"ModalLogout_overlay__pFQVM","title":"ModalLogout_title__Fc1--","closeButton":"ModalLogout_closeButton__rqP1R"};